import React, { useState } from 'react';
import { Activity, Heart, ShieldCheck, CheckCircle2 } from 'lucide-react';

export const HospitalRehabModule: React.FC = () => {
  const [selectedBed, setSelectedBed] = useState('Bed 302-A (Pediatric Neuro)');
  const [heartRate, setHeartRate] = useState(72);
  const [spO2, setSpO2] = useState(98);
  const [dischargeReady, setDischargeReady] = useState(true);
  const [loggedMsg, setLoggedMsg] = useState('');

  const handleLogVitals = () => {
    setLoggedMsg('Patient vital signs and clinical rounds note logged!');
    setTimeout(() => setLoggedMsg(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-blue-100 text-blue-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Inpatient Rehabilitation Hospital Workspace
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Rehabilitation Hospital Patient Care</h2>
          <p className="text-xs text-slate-500">Inpatient ward bed manager, multidisciplinary care rounds, and discharge scorecards</p>
        </div>

        <button 
          onClick={handleLogVitals}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <Activity className="w-4 h-4" />
          <span>Log Clinical Vitals</span>
        </button>
      </div>

      {loggedMsg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {loggedMsg}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <label className="block text-xs font-bold text-slate-700">Assigned Inpatient Bed</label>
          <select 
            value={selectedBed}
            onChange={(e) => setSelectedBed(e.target.value)}
            className="w-full px-3 py-2 border rounded-xl text-xs font-bold bg-white focus:ring-2 focus:ring-blue-500"
          >
            <option value="Bed 302-A (Pediatric Neuro)">Bed 302-A (Pediatric Neuro)</option>
            <option value="Bed 304-B (Post-Spinal Surgery)">Bed 304-B (Post-Spinal Surgery)</option>
            <option value="Bed 308-C (Traumatic Brain Injury)">Bed 308-C (Traumatic Brain Injury)</option>
          </select>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold text-slate-700">Heart Rate (BPM)</span>
            <span className="text-sm font-black text-rose-600 font-mono">{heartRate} BPM</span>
          </div>
          <input 
            type="range" min="50" max="140" value={heartRate}
            onChange={(e) => setHeartRate(parseInt(e.target.value))}
            className="w-full accent-rose-600"
          />
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold text-slate-700">Oxygen Saturation (SpO2)</span>
            <span className="text-sm font-black text-blue-600 font-mono">{spO2}%</span>
          </div>
          <input 
            type="range" min="80" max="100" value={spO2}
            onChange={(e) => setSpO2(parseInt(e.target.value))}
            className="w-full accent-blue-600"
          />
        </div>
      </div>
    </div>
  );
};
